import productCustomNecklace from './pages/product-custom-necklace';
import productCustomBracelet from './pages/product-custom-bracelet';
import productCustomCharm from './pages/product-custom-charm';
import productCustomEarring from './pages/product-custom-earring';
import productCustomRing from './pages/product-custom-ring';
import collectionCustomLetter from './pages/collection-custom-letter';
import pageBirthstone from './pages/page-birthstone';

function router() {
    if (/\/custom-letter-necklace/ig.test(location.pathname)) {
        productCustomNecklace();
    }

    if (/\/custom-letter-bracelet/ig.test(location.pathname)) {
        productCustomBracelet();
    }

    if (/\/custom-letter-charm/ig.test(location.pathname)) {
        productCustomCharm();
    }

    if (/\/custom-letter-earring/ig.test(location.pathname)) {
        productCustomEarring();
    }

    if (/\/custom-letter-ring/ig.test(location.pathname)) {
        productCustomRing();
    }

    if (/\/nameplates/ig.test(location.pathname)) {
        collectionCustomLetter();
    }

    if (/\/collections\/birthstone/ig.test(location.pathname)) {
        pageBirthstone();
    }
}

router();
